import React from 'react';
import { useCanRender } from '../../../../hooks';
import NcdCancellationPolicyAcceptanceModal from './NcdCancellationPolicyAcceptanceModal';

export interface INcdCancellationPolicyAcceptanceModalContainerProps {
  visible: boolean;
  providerId: number;
  onAccept: () => void;
}

const NcdCancellationPolicyAcceptanceModalContainer:
React.FC<INcdCancellationPolicyAcceptanceModalContainerProps> = ({
  visible,
  providerId,
  onAccept,
}) => {
  const shouldShow = useCanRender(visible);
  return (
    shouldShow && (
      <NcdCancellationPolicyAcceptanceModal
        providerId={providerId}
        onAccept={onAccept}
      />
    )
  );
};

export default NcdCancellationPolicyAcceptanceModalContainer;
